module.exports = __webpack_public_path__ + "img/icon_menu_logo.39db220c.png";